




















































import { Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { LogScreenGroup } from '@/core/interfaces/logScreenGroup';
import { LogScreen } from '@/core/interfaces/logScreen';
import Loader from '@/components/Loader.vue';

@Component({
    components: { Loader },
})
export default class DashboardLogs extends Vue {
    activeScreen: string | null = null;
    numberOfLines = 200;
    loading = false;

    @Getter('vehicleDashboard/logScreens')
    logScreens!: (LogScreenGroup | LogScreen)[];

    @Getter('vehicleDashboard/logs')
    logs!: string;

    mounted(): void {
        this.$store.dispatch('vehicleDashboard/loadLogScreens');
        this.$store.commit('vehicleDashboard/setLogs', null);
    }

    async fetchLogs(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch('vehicleDashboard/loadLogs', {
            screen: this.activeScreen,
            numberOfLines: this.numberOfLines,
        });
        this.loading = false;
    }

    @Watch('logs')
    scrollToBottom(): void {
        this.$nextTick(() => {
            const logsElement = this.$refs.logs as HTMLElement;
            if (logsElement) {
                logsElement.scrollTop = logsElement.scrollHeight;
            }
        });
    }
}
